<template>
  <v-stepper-items>
    <v-stepper-content class="pa-0" step="2">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6" xl="6">
          <v-container class="py-0">
            <v-card class="card py-5 my-3">
              <h3 class="text-center mb-3" translate>
                {{ $t(["DONATION INFORMATION"]) }}
              </h3>

              <v-divider class="mx-3"></v-divider>

              <v-row justify="center" no-gutters>
                <v-form ref="donationForm">
                  <v-radio-group
                    v-model="selectedAmountRadioButton"
                    class="ma-0 px-0 pt-5 pb-3 justify-center error-field center-error-text"
                    mandatory
                    :hide-details="donationSelectionError"
                    :error="!donationSelectionError"
                    :error-messages="donationSelectionErrorMessage"
                  >
                    <v-row class="mb-5" no-gutters>
                      <v-col cols="6">
                        <v-radio
                          class="mx-5"
                          :key="donationAmounts[0]"
                          :value="donationAmounts[0]"
                        >
                          <template slot="label">
                            <span
                              v-html="
                                $t('Currency', {
                                  amount: donationAmounts[0].toFixed(2),
                                })
                              "
                            ></span>
                          </template>
                        </v-radio>
                      </v-col>

                      <v-col cols="6">
                        <v-radio
                          class="mx-5"
                          :key="donationAmounts[1]"
                          :value="donationAmounts[1]"
                        >
                          <template slot="label">
                            <span
                              v-html="
                                $t('Currency', {
                                  amount: donationAmounts[1].toFixed(2),
                                })
                              "
                            ></span>
                          </template>
                        </v-radio>
                      </v-col>
                    </v-row>

                    <v-row class="mb-5" no-gutters>
                      <v-col cols="6">
                        <v-radio
                          class="mx-5"
                          :key="donationAmounts[2]"
                          :value="donationAmounts[2]"
                        >
                          <template slot="label">
                            <span
                              v-html="
                                $t('Currency', {
                                  amount: donationAmounts[2].toFixed(2),
                                })
                              "
                            ></span>
                          </template>
                        </v-radio>
                      </v-col>

                      <v-col cols="6">
                        <v-radio
                          class="mx-5"
                          :key="donationAmounts[3]"
                          :value="donationAmounts[3]"
                        >
                          <template slot="label">
                            <span
                              v-html="
                                $t('Currency', {
                                  amount: donationAmounts[3].toFixed(2),
                                })
                              "
                            ></span>
                          </template>
                        </v-radio>
                      </v-col>
                    </v-row>

                    <v-row class="mb-5" no-gutters>
                      <v-col class="mb-0">
                        <v-input
                          v-model="selectedAmountRadioButton"
                          class="ma-0"
                          hide-details
                        >
                          <!-- <div placeholder="{{ 'Other' | translate }}"></div> -->
                          <v-radio
                            :label="$t(['Other'])"
                            value="Other"
                            class="mb-0 mr-5 mx-5"
                            hide-details
                          ></v-radio>

                          <div style="width: 130px">
                            <v-text-field
                              @click="selectOtherRadioButton()"
                              v-model="otherAmount"
                              class="ma-0"
                              :prefix="$i18n.locale == 'en' ? '$' : ''"
                              :suffix="$i18n.locale == 'fr' ? '$' : ''"
                              maxlength="8"
                              outlined
                              dense
                              hide-details
                              @blur="maskCurrency"
                            ></v-text-field>
                          </div>
                        </v-input>
                      </v-col>
                    </v-row>

                    <v-row no-gutters>
                      <v-radio
                        :label="$t(['I have already made my donation'])"
                        class="mx-5 mb-2"
                        :value="donationAmounts[4]"
                      >
                      </v-radio>
                    </v-row>
                  </v-radio-group>
                </v-form>
              </v-row>

              <v-divider class="mx-3"></v-divider>

              <div v-show="donationAmount > 0 && !hasRegistration">
                <h3 class="text-center my-3" translate>
                  {{ $t(["TAX RECEIPT INFORMATION"]) }}
                </h3>

                <v-divider class="mx-3"></v-divider>

                <v-form ref="taxReceiptForm">
                  <v-row class="my-0 mx-3 mt-3">
                    <v-col cols="12" sm="6" class="py-0">
                      <v-text-field
                        id="firstName"
                        :label="$t(['First Name'])"
                        class="px-3 error-field"
                        v-model.trim="firstName"
                        :rules="rules.firstName"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" class="py-0">
                      <v-text-field
                        id="lastName"
                        :label="$t(['Last Name'])"
                        class="px-3 error-field"
                        v-model.trim="lastName"
                        :rules="rules.lastName"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="my-0 mx-3">
                    <v-col cols="12" sm="6" class="py-0">
                      <v-combobox
                        id="address"
                        :label="$t(['Address_Label'])"
                        class="px-3 error-field"
                        v-model="address"
                        :loading="isAddressLoading"
                        :search-input.sync="searchInput"
                        :rules="rules.address"
                        :items="filteredAddresses"
                        item-text="name"
                        item-value="placeId"
                        @change="populateFields($event)"
                        ><template v-slot:selection="{ item }">
                          {{ item.mainText }}
                        </template>
                      </v-combobox>
                    </v-col>

                    <v-col cols="12" sm="6" class="py-0">
                      <v-text-field
                        id="address2"
                        :label="$t(['App, Suite, ...'])"
                        class="px-3"
                        v-model.trim="app_suite"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row class="my-0 mx-3">
                    <v-col cols="12" sm="6" class="py-0">
                      <v-text-field
                        id="city"
                        :label="$t(['City/Town'])"
                        class="px-3 error-field"
                        v-model.trim="city"
                        :rules="rules.city"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" class="py-0">
                      <v-select
                        id="province"
                        :label="$t(['Province_Label'])"
                        class="px-3 error-field"
                        auto-select-first
                        v-model="province"
                        :rules="rules.province"
                        :item-color="'primary'"
                        :items="
                          Object.keys(store.canadaProvinceOptions).map(
                            (province) => {
                              return $t(province);
                            }
                          )
                        "
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row class="my-0 mx-3">
                    <v-col cols="12" sm="6" class="py-0">
                      <v-text-field
                        id="postalCode"
                        :label="$t(['PostalCode_Label'])"
                        class="px-3 error-field"
                        v-model="postalCode"
                        v-mask="'A#A #A#'"
                        :rules="rules.postalCode"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" class="py-0">
                      <v-text-field
                        id="email"
                        :label="$t(['Email_Label'])"
                        class="px-3 error-field"
                        v-model.trim="email"
                        :rules="rules.email"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>

                <v-divider class="mx-3"></v-divider>
              </div>

              <v-row
                class="mt-3"
                v-show="store.orderInfo.type == 'Merchandise'"
              >
                <v-col cols="6" align="center">
                  <v-btn
                    class="btn-text"
                    large
                    translate
                    @click="previousStep()"
                  >
                    {{ $t(["Back"]) }}
                  </v-btn>
                </v-col>
                <v-col cols="6" align="center">
                  <v-btn
                    class="btn-text"
                    color="primary"
                    large
                    @click="nextStep()"
                  >
                    {{ $t(["Next"]) }}
                  </v-btn>
                </v-col>
              </v-row>

              <v-row
                class="mt-3"
                v-show="store.orderInfo.type == 'RegisterAndDonate'"
              >
                <v-col cols="12" align="center">
                  <v-btn
                    class="btn-text"
                    color="primary"
                    large
                    @click="nextStep()"
                  >
                    {{ $t(["Next"]) }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-col>
      </v-row>
    </v-stepper-content>
  </v-stepper-items>
</template>

<script>
import { useFormDataStore } from "../../../store/formData.js";

import gmapsInit from "@/utils/gmaps.js";

export default {
  name: "S2_DonationInfo",
  data: () => {
    return {
      // Donation Information
      selectedAmountRadioButton: "",
      donationAmount: 0,
      donationAmounts: [25, 50, 100, 200, 0],
      otherAmount: "",
      validOtherAmount: 0,
      donationSelectionError: true,
      donationSelectionErrorMessage: null,

      // Tax Receipt Information
      firstName: "",
      lastName: "",
      address: "",
      app_suite: "",
      city: "",
      province: "",
      postalCode: "",
      email: "",
      rules: {
        firstName: [],
        lastName: [],
        address: [],
        city: [],
        province: [],
        postalCode: [],
        email: [],
      },

      searchInput: null,
      isAddressLoading: false,
      autoCompleteService: null,
      geocoder: null,
      filteredAddresses: [],
    };
  },
  setup() {
    const store = useFormDataStore();

    return {
      store,
    };
  },
  props: {
    hasRegistration: Boolean,
  },
  async mounted() {
    let google = await gmapsInit();

    if (google) {
      this.autoCompleteService =
        new window.google.maps.places.AutocompleteService();
      this.geocoder = new window.google.maps.Geocoder();
    } else {
      console.error("Google Maps API error");
    }
  },
  watch: {
    "$i18n.locale"() {
      this.$refs.donationForm.resetValidation();

      this.donationSelectionError = true;
      this.donationSelectionErrorMessage = null;
    },
    postalCode() {
      this.postalCode = this.postalCode.toUpperCase();
    },
    selectedAmountRadioButton(amountRadioButton) {
      // Set donation amount based on current radio button selection
      if (amountRadioButton == "Other") {
        this.donationAmount =
          this.otherAmount != "" ? parseFloat(this.otherAmount) : 0;
      } else {
        // Clear minimum donation amount error if currently active and clear 'Other' amount field
        this.donationSelectionError = true;
        this.donationSelectionErrorMessage = null;
        this.otherAmount = "";

        this.donationAmount = amountRadioButton;
      }
    },
    otherAmount(amount) {
      let currencyRegex =
        /^\$?([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\-?\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$/; // eslint-disable-line no-useless-escape

      if (
        currencyRegex.exec(amount) &&
        this.selectedAmountRadioButton == "Other"
      ) {
        this.donationAmount = this.validOtherAmount =
          parseFloat(amount).toFixed(2);
      } else if (amount == "") {
        this.validOtherAmount = (0).toFixed(2);
      }

      // Clear minimum donation amount error if currently active
      if ((this.validOtherAmount >= 3) & !this.donationSelectionError) {
        this.donationSelectionError = true;
        this.donationSelectionErrorMessage = null;
      }
    },
    searchInput() {
      if (this.searchInput == null || this.searchInput == "") {
        this.filteredAddresses = [];
      } else {
        this.isAddressLoading = true;
        this.autoCompleteService.getPlacePredictions(
          {
            input: this.searchInput,
            componentRestrictions: { country: ["ca"] },
            types: ["address"],
          },
          this.addressSearchResults
        );
      }

      this.isAddressLoading = false;
    },
  },
  methods: {
    addressSearchResults(predictions, status) {
      // console.log(predictions);
      // console.log(status);

      if (status == "OK") {
        this.filteredAddresses = [];

        predictions.forEach((place) => {
          this.filteredAddresses.push({
            name: place.description,
            placeId: place.place_id,
            mainText: place.structured_formatting.main_text,
          });
        });
      }
    },
    populateFields(address) {
      if (address && address.placeId) {
        this.geocoder
          .geocode({
            placeId: address.placeId,
          })
          .then((result) => {
            result.results[0].address_components.forEach((component) => {
              if (component.types.includes("locality")) {
                this.city = component.long_name;
              } else if (
                component.types.includes("administrative_area_level_2") &&
                !component.types.includes("locality")
              ) {
                this.city = component.long_name;
              } else if (
                component.types.includes("administrative_area_level_1")
              ) {
                this.province = component.long_name;
              } else if (component.types.includes("postal_code")) {
                this.postalCode = component.long_name;
              }
            });

            this.$nextTick(() => {
              document.querySelector("#email").focus();
            });
          });
      } else {
        this.filteredAddresses = [];
      }
    },
    maskCurrency() {
      this.otherAmount = this.donationAmount = parseFloat(
        this.validOtherAmount
      ).toFixed(2);
    },
    setFieldValidationRules() {
      this.rules.firstName = [(v) => !!v.trim() || this.$t(["Required"])];
      this.rules.lastName = [(v) => !!v.trim() || this.$t(["Required"])];
      this.rules.address = [(v) => !!v || this.$t(["Required"])];
      this.rules.city = [(v) => !!v.trim() || this.$t(["Required"])];
      this.rules.province = [(v) => !!v || this.$t(["Required"])];
      this.rules.postalCode = [
        (v) => !!v || this.$t(["Required"]),
        (v) =>
          (v || "").length >= 7 ||
          this.$gettext(this.$t(["Invalid postal code"])),
      ];

      let emailRegex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
      this.rules.email = [
        (v) => !!v.trim() || this.$t(["Required"]),
        (v) => emailRegex.test(v) || this.$gettext(this.$t(["Invalid e-mail"])),
      ];
    },
    async nextStep() {
      await this.setFieldValidationRules();

      if (this.donationAmount > 0 && !this.hasRegistration) {
        // Checks if amount entered amount in 'Other' field is at least $10.00 or higher; otherwise will show an error
        if (this.selectedAmountRadioButton == "Other") {
          if (this.validOtherAmount < 3) {
            this.donationSelectionError = false;
            this.donationSelectionErrorMessage = [
              this.$t(["Minimum donation amount is $3.00"]),
            ];

            this.$nextTick(() => {
              const el = this.$el.querySelector(
                ".v-messages.error--text:first-of-type"
              );
              this.$vuetify.goTo(-5, el);

              return;
            });

            return;
          } else {
            this.donationSelectionError = true;
            this.donationSelectionErrorMessage = null;
          }
        }

        if (this.$refs.taxReceiptForm.validate()) {
          this.store.setRegistrationInfoFormData({
            firstName: this.firstName.trim(),
            lastName: this.lastName.trim(),
            address:
              this.address instanceof Object
                ? this.address.mainText
                : this.address.trim(),
            address2: this.app_suite.trim(),
            city: this.city.trim(),
            province:
              this.$i18n.locale == "en"
                ? this.store.canadaProvinceOptions[this.province]
                : this.store.canadaProvinceOptionsFR[this.province],
            phone: this.store.orderInfo.phoneNumber,
            registrationPostalCode: this.postalCode,
            email: this.email.trim(),
          });
        } else {
          this.$nextTick(() => {
            const el = this.$el.querySelector(
              ".v-messages.error--text:first-of-type"
            );
            this.$vuetify.goTo(-5, el);

            return;
          });

          return;
        }
      } else {
        this.$refs.taxReceiptForm.resetValidation();
      }

      this.store.setDonationInfoFormData({
        donationAmount: parseFloat(this.donationAmount),
      });

      this.$emit("nextStepFromTwo");
    },
    previousStep() {
      this.$emit("previousStepFromTwo");
    },
    selectOtherRadioButton() {
      this.selectedAmountRadioButton = "Other";
    },
  },
};
</script>

<style lang="scss" scoped>
// Center error message
.center-error-text ::v-deep .v-messages {
  text-align: center;
}
</style>
